<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <div class="flex h-svh flex-col">
    <div class="p-lg border-stroke-neutral-light flex justify-between border-b bg-white">
      <div class="gap-xxs flex">
        <a [routerLink]="['..']" size="xxl" hlmBtn variant="ghost" size="icon">
          <ng-icon name="lucideArrowLeft" hlm />
        </a>
        <div class="gap-xs flex flex-col">
          <h1 class="title-small-semibold">Ajouter des formations</h1>
          <p>
            Sélectionnez les formations à ajouter à votre Centre de Formation
            <span class="component-medium-semibold">Maison de {{ site().nom }}</span
            >.
          </p>
        </div>
      </div>
      <div>
        <div class="gap-xs flex">
          <button hlmBtn variant="secondary" type="submit">Confirmer la sélection</button>
          <button [appBadge]="nbFiltres()" (click)="openFiltres()" size="xxl" hlmBtn variant="secondary" type="button">
            <ng-icon name="lucideListFilter" />
          </button>
        </div>
      </div>
    </div>

    <section class="m-lg h-full overflow-y-auto bg-white !py-0" hlmCard>
      <div class="!p-lg gap-xl grid" hlmCardContent>
        @for (institut of data(); track $index) {
          <app-expansion-panel [item]="institut" [titre]="institut.nom">
            <div class="gap-xs ml-auto flex items-center" ngProjectAs="chipRight">
              <app-chip [label]="institut.referentiels | computeFormationsParIm | i18nPlural: formationMapping" />
              <hlm-checkbox
                [checked]="isCheckedInstitut(institut)"
                [indeterminate]="isIndeterminateInstitut(institut)"
                (click)="$event.stopPropagation()"
                (checkedChange)="onChangeInstitut(institut)"
              />
            </div>
            <div class="p-xs gap-xs grid">
              @for (referentiel of institut.referentiels; track referentiel.id) {
                <app-expansion-panel [item]="referentiel" [titre]="referentiel.nom">
                  <div class="gap-xs ml-auto flex items-center" ngProjectAs="chipRight">
                    <app-chip [label]="referentiel.etapes.length | i18nPlural: formationMapping" />
                    <hlm-checkbox
                      [checked]="isCheckedReferentiel(institut.key, referentiel.id)"
                      [indeterminate]="isIndeterminateReferentiel(institut.key, referentiel.id)"
                      (click)="$event.stopPropagation()"
                      (checkedChange)="onChangeReferentiel(institut.key, referentiel.id)"
                    />
                  </div>
                  <div class="p-md gap-md grid grid-cols-3">
                    @for (etape of referentiel.etapes | trierPar: 'nom'; track etape.id) {
                      <app-card-etape
                        [etape]="etape"
                        (click)="onClickEtape(etape)"
                        classes="hover:bg-background-underground hover:cursor-pointer"
                      >
                        <hlm-checkbox [checked]="isChecked(etape.id)" />
                      </app-card-etape>
                    } @empty {
                      <span class="text-content-secondary paragraph-medium-medium"
                        >Il n’y a pas encore d'étapes associées.</span
                      >
                    }
                  </div>
                </app-expansion-panel>
              } @empty {
                <span class="paragraph-medium-medium text-content-secondary">Pas de référentiels.</span>
              }
            </div>
          </app-expansion-panel>
        }
      </div>
    </section>
  </div>
</form>
